import { useMemo } from "react";

import { GraficoBarras } from "./components/charts/GraficoBarras";

import {
  ChartCard,
  ChartHeader,
  ConteudoRelatorio,
  RelatorioContainer,
  TotalItem,
  Totals,
} from "./styles";

import {
  GraficoGerencialResponse,
  SerieGrafico,
  TipoRelatorioGrafico,
} from "./types";

type GraficoGerencialProps = {
  relatorio: TipoRelatorioGrafico;
  resposta: GraficoGerencialResponse;
};

export default function GraficoGerencial({
  relatorio,
  resposta,
}: GraficoGerencialProps) {
  const ehVendas = relatorio === "Vendas Mensais";

  const ehPassageiros = relatorio === "Passageiros Mensais";

  const seriesVendas = useMemo<SerieGrafico[]>(
    () => [
      {
        dataKey: "valorTotal",
        nome: "Valor Total",
        cor: "#1976d2",
      },
      {
        dataKey: "valorLiquido",
        nome: "Valor Líquido",
        cor: "#2e7d32",
      },
      {
        dataKey: "comissao",
        nome: "Comissão",
        cor: "#ed6c02",
      },
    ],
    [],
  );

  const seriesPassageiros = useMemo<SerieGrafico[]>(
    () => [
      {
        dataKey: "adultos",
        nome: "Adultos",
        cor: "#1976d2",
      },
      {
        dataKey: "criancas",
        nome: "Crianças",
        cor: "#e91e63",
      },
    ],
    [],
  );

  return (
    <RelatorioContainer>
      <ChartHeader>
        <div>
          <h3>{resposta.titulo}</h3>
          <span>{resposta.periodo}</span>
        </div>

        <button
          type="button"
          onClick={(event) => {
            event.currentTarget.ownerDocument.defaultView?.print();
          }}
        >
          Imprimir
        </button>
      </ChartHeader>

      <ConteudoRelatorio $comTotais={ehPassageiros}>
        <ChartCard>
          {ehVendas && (
            <GraficoBarras
              dados={resposta.dados}
              series={seriesVendas}
              formatarComoMoeda
              altura={540}
            />
          )}

          {ehPassageiros && (
            <GraficoBarras
              dados={resposta.dados}
              series={seriesPassageiros}
              altura={540}
            />
          )}
        </ChartCard>

        {ehPassageiros && (
          <Totals>
            <TotalItem>
              <span>Total de adultos</span>
              <strong>
                {(resposta.totalAdultos ?? 0).toLocaleString("pt-BR")}
              </strong>
            </TotalItem>

            <TotalItem>
              <span>Total de crianças</span>
              <strong>
                {(resposta.totalCriancas ?? 0).toLocaleString("pt-BR")}
              </strong>
            </TotalItem>

            <TotalItem>
              <span>Total geral</span>
              <strong>
                {(
                  (resposta.totalAdultos ?? 0) + (resposta.totalCriancas ?? 0)
                ).toLocaleString("pt-BR")}
              </strong>
            </TotalItem>
          </Totals>
        )}
      </ConteudoRelatorio>
    </RelatorioContainer>
  );
}
